import {useState} from "react";
import {Button, Identifier, useNotify} from "react-admin";
import {clientNoJson} from "../../../dataProvider";
import {getFileNameFromContentDisposition} from "../../../shared/utils";
import {CircularProgress} from "@material-ui/core";
import PublishIcon from "@material-ui/icons/Print";

export const PrintInvoiceTimeTableButtonSingleClient = ({ ids, type }: { ids?: Identifier[], type: string }) => {
    const notify = useNotify();
    const [loading, setLoading] = useState(false);
    const handleSubmit = async (e: any) => {
      e.stopPropagation();
      setLoading(true);
      let res = null;
      try {
        res = await clientNoJson(`/api/payment_schedule/print_pdf_single_client/`, {
          method: "POST",
          data: {
            ids: ids,
              type: type,
          },
          responseType: "arraybuffer",
        });
      } catch (err) {
        notify("ra.message.error", "error");
        setLoading(false);
        return;
      }
      setLoading(false);
      const data = res.data; // or res.blob() if using blob responses
  
      const url = window.URL.createObjectURL(
        new Blob([data], {
          type: res.headers["content-type"],
        })
      );
      const actualFileName = getFileNameFromContentDisposition(
        res.headers["content-disposition"]
      );
  
      // uses the download attribute on a temporary anchor to trigger the browser
      // download behavior. if you need wider compatibility, you can replace this
      // part with a library such as filesaver.js
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", actualFileName);
      document.body.appendChild(link);
      link.click();
      if (link.parentNode) link.parentNode.removeChild(link);
  
  
    };
  
    return (
      <Button
        disabled={loading}
        label={`Stampa scadenzario ${type === "P" ? '(singolo fornitore)' : '(singolo cliente)'}`}
        title="Stampa estratto conto con attività"
        onClick={handleSubmit}
      >
        {loading ? <CircularProgress size={18} thickness={2} /> : <PublishIcon />}
      </Button>
    );
  };